import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import {
  IconStyled,
  SocialNetworkContainer,
} from './SocialNetworksHemera.styles';

const Icon = ({ iconName, link, hasMarginRight }) => (
  <IconStyled
    href={link}
    target="_blank"
    rel="noopener"
    hasMarginRight={hasMarginRight}
  >
    <FontAwesomeIcon icon={iconName} />
  </IconStyled>
);

Icon.propTypes = {
  iconName: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
  hasMarginRight: PropTypes.bool,
};

export const SocialNetworksHemera = () => (
  <SocialNetworkContainer>
    <Icon
      iconName={faLinkedinIn}
      link="https://www.linkedin.com/company/hemera-capital-partners"
      hasMarginRight
    />
  </SocialNetworkContainer>
);
